export type JwtPayload = Record<string, unknown> & {
  exp?: number
}

export type JwtSessionScope = 'user' | 'account'

export function decodeJwtPayload(token: string | null | undefined): JwtPayload | null {
  try {
    const segments = token?.split('.')
    if (segments?.length !== 3) return null

    const [header, payloadSegment, signature] = segments
    if (!header || !payloadSegment || !signature) return null

    const payload = payloadSegment.replaceAll('-', '+').replaceAll('_', '/')
    const decoded = JSON.parse(
      atob(payload.padEnd(payload.length + ((4 - payload.length) % 4), '='))
    )

    return decoded && typeof decoded === 'object' && !Array.isArray(decoded) ? decoded : null
  } catch {
    return null
  }
}

export function getJwtSessionScope(token: string | null | undefined): JwtSessionScope | null {
  const payload = decodeJwtPayload(token)
  if (!payload) return null

  const account = payload.account
  return typeof account === 'string' && account.trim().length > 0 ? 'account' : 'user'
}
